import { CheckboxField as BaseCheckboxField } from '@wyz/ui';
import * as React from 'react';
import { useI18n } from '~/common/context';

type CheckboxFieldProps = React.ComponentProps<typeof BaseCheckboxField>;
const CheckboxField = (props: Omit<CheckboxFieldProps, 'translate'>) => {
  const { t } = useI18n();

  return <BaseCheckboxField {...props} translate={t} />;
};

export default CheckboxField;
